<template>
		<modal-bottom-sheet
			size="full"
			:hideCloseButton="true">
			<template slot="header">
				{{ $t('Edit Lower Third') }}
			</template>
			<template slot="body">
				<div class="form-group mb-3" v-if="isH1Active">
					<custom-input
						class="mb-3"
						align="left"
						:label="$t('H1')"
						:required="isRequired"
						@keyenter="save"
						v-model="h1"
						v-if="isH1Active"
						:max="9999"
					/>
				</div>
				<div class="form-group mb-3" v-if="isH2Active">
					<custom-input
						class="mb-3"
						align="left"
						:label="$t('H2')"
						:required="isRequired"
						@keyenter="save"
						v-model="h2"
						:max="9999"
					/>
				</div>
				<div class="form-group mb-3" v-if="isH3Active">
					<custom-input
						class="mb-3"
						align="left"
						:label="$t('H3')"
						:required="isRequired"
						@keyenter="save"
						v-model="h3"
						v-if="isH3Active"
						:max="9999"
					/>
				</div>
				<div class="form-group mb-3" v-if="isH4Active">
					<custom-input
						class="mb-3"
						align="left"
						:label="$t('H4')"
						:required="isRequired"
						@keyenter="save"
						v-model="h4"
						v-if="isH4Active"
						:max="9999"
					/>
				</div>
				<div v-if="!isH1Active && !isH2Active && !isH3Active && !isH4Active">
					{{$t('There is no element to edit')}}
				</div>
			</template>
			<template slot="footer">
				<div class="w-100 flex-center">
					<button class="btn btn-default" @click="closeModal">
						{{ $t('Cancel') }}
					</button>
					<button v-if="isH1Active || isH2Active || isH3Active || isH4Active" class="btn btn-primary" :class="{ 'is-loading': isSaving }" @click="save()">
						{{ $t('Save Changes') }}
					</button>
				</div>
			</template>
	</modal-bottom-sheet>
</template>

<script>
// import MaskedInput from 'vue-masked-input';
// import Scrubber from '@/components/Scrubber.vue';
import $ from 'jquery';
import { mapGetters } from 'vuex';
import localforage from 'localforage';
import ModalBottomSheet from '@/components/ModalBottomSheet.vue';

import CustomInput from '@/components/CustomInput.vue';

import fileApi from '@/api/file';
import mediasApi from '@/api/medias';
import {
	lottieSpeedOptions,
	lottieScaleOptions,
	delayList,
} from '@/lib/statics';
import {
	getAxiosErrorMessage,
	delay,
	duplicateVar,
} from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';

export default {
	name: 'LowerThirdProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		media: {
			type: Object,
		},
		template: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		CustomInput,
		ModalBottomSheet,
	},
	data() {
		return {
			min: 0,
			max: 200,
			steps: 1,
			value: 100,
			loop: false,
			isLoading: false,
			mediaFile: '',
			mediaUrl: '',
			mediaThumbnail: '',
			mediaLabel: '',
			mediaLoop: false,
			mediaType: 'image',
			mediaProgress: 0,

			templateFile: '',
			templates: [],
			textDropShadow: false,
			gradient: false,
			selectedTemplate: null,
			h1: '',
			h2: '',
			h3: '',
			h4: '',

			isImageActive: false,

			isH1Active: false,
			isH2Active: false,
			isH3Active: false,
			isH4Active: false,

			isH1ColorActive: false,
			isH2ColorActive: false,
			isH3ColorActive: false,
			isH4ColorActive: false,

			isElement1Active: false,
			isElement2Active: false,
			isElement3Active: false,
			isElement4Active: false,

			label: '',
			duration: '00:00',
			layerIndex: 0,
			font: '',
			fontSize: '',
			h1Color: '#FF00FF',
			h2Color: '#FF0000',
			h3Color: '#FF0000',
			h4Color: '#FF0000',

			color1: '#FF000F',
			color2: '#F000FF',
			color3: '#FF000F',
			color4: '#F000FF',

			width: 0,
			height: 0,
			position: 'bottom-left',
			x: 0,
			y: 0,
			isVisible: true,
			progress: 0,
			lottieSpeedOptions: duplicateVar(lottieSpeedOptions),
			lottieScaleOptions: duplicateVar(lottieScaleOptions),
			isUploading: false,
			isSaving: false,

			// color picker
			isshowColorPickerh1Color: false,
			isshowColorPickerh2Color: false,
			isshowColorPickerh3Color: false,
			isshowColorPickerh4Color: false,
			isshowColorPickerColor1: false,
			isshowColorPickerColor2: false,
			isshowColorPickerColor3: false,
			isshowColorPickerColor4: false,
			isRequired: false,
			isRatio: true,
			isUploadingMedia: false,
			isFetchingMedia: false,
			isActiveEdit: false,
			// mediaItems: [],
			uploadLimit: '',
			isEnableUploadLimit: false,
			settings: null,
			fileSize: '',
			lottieSpeed: '1',
			lottieScale: 'default',
			downloadedTemplate: null,

			// loader
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',

			localClientUser: {},
			parentItem: null,
			isParent: false,
			delayList,
			childOrder: { name: 'No Delay', id: 0 },
		};
	},
	methods: {
		closeModal() {
			this.$emit('close');
		},
		onSelect() {
			this.save();
		},
		playPreview(reFetch = false) {
			if (this.data.is_Locked) return; // Disable when ed
			const id = this.data.id;
			const status = 'preview';
			// eslint-disable-next-line no-unused-vars
			const callback = (response) => {
				if (reFetch) {
					const item = response.data;
					const currentItem = item.find(({ id }) => id === this.data.id);

					if (currentItem && !currentItem.is_play_preview) {
						this.playPreview();
					}
					this.save();
				}
				// if
				// const items = response.data;
			};
			const errorCallback = () => {
			};
			const userActivateAllItem = this.userSettings && this.userSettings.is_enable_all_preview ? this.userSettings.is_enable_all_preview : false;
			const params = {
				isAllItem: userActivateAllItem,
			};
			rundownItemsApi.togglePlay(id, status, params, callback, errorCallback);
		},
		setSpeed() {
			this.playPreview(true);
			// this.onKeywordChange();
		},
		deactiveTemplateProperty() {
			this.isH1Active = false;
			this.isH2Active = false;
			this.isH3Active = false;
			this.isH4Active = false;
			this.isH1ColorActive = false;
			this.isH2ColorActive = false;
			this.isH3ColorActive = false;
			this.isH4ColorActive = false;
			this.isElement1Active = false;
			this.isElement2Active = false;
			this.isElement3Active = false;
			this.isElement4Active = false;
		},
		async lottieDataChange(template, isSame = false, isReset = false, changeTemplate = false) {
			const lottieKey = `lottie_lt_${this.data.id}`;
			const url = template && template.file_path ? template.file_path : null;
			if (!isSame) {
				this.isImageActive = false;
				this.deactiveTemplateProperty();
			}
			if (url) {
				let data = null;
				localforage.getItem(lottieKey).then(async (value) => {
					if (value) {
						data = value;
					} else {
						data = await (await fetch(url)).json();
						// eslint-disable-next-line no-unused-vars
						localforage.setItem(lottieKey, data).then(() => localforage.getItem(lottieKey)).then((value) => {
							// we got our value
						// eslint-disable-next-line no-unused-vars
						}).catch((err) => {
							// we got an error
						});
					}
					this.parseLottieData(data, isReset, isSame);
				});
				this.downloadedTemplate = duplicateVar(data);
			}
			if (changeTemplate) {
				this.resetSizePosition();
				this.save();
			}
		},
		parseLottieData(data, isReset = false, isSame) {
			$.each(data.layers, (k, obj) => {
				if (data.w && data.h) {
					// this.width 	= data.w;
					// this.height	= data.h;
					if (this.position === 'default') {
						this.y = (this.height - 1080) * -1; // (lottie.height - canvas.height ) *- 1;
					}
				}
				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H1TEXT') {
					this.isH1Active = true;
					this.isH1ColorActive = true;
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H2TEXT') {
					this.isH2Active = true;
					this.isH2ColorActive = true;
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H3TEXT') {
					this.isH3Active = true;
					this.isH3ColorActive = true;
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'H4TEXT') {
					this.isH4Active = true;
					this.isH4ColorActive = true;
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'ELEMENT1') {
					this.isElement1Active = true;
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'ELEMENT2') {
					this.isElement2Active = true;
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'ELEMENT3') {
					this.isElement3Active = true;
				}

				// eslint-disable-next-line eqeqeq
				if (obj.nm == 'ELEMENT4') {
					this.isElement4Active = true;
				}
				// eslint-disable-next-line eqeqeq
				if (obj && obj.ef && obj.ef[0] && obj.ef[0].nm == 'isHasImage') {
					this.isImageActive = obj.ef[0].ef[0].v.k;
					// array does not exist, is not an array, or is empty
				}
				if (isReset) {
					// eslint-disable-next-line eqeqeq
					if (obj.nm == 'H1TEXT') this.h1Color = this.rgbaobjtohex(obj.t.d.k[0].s.fc);
					// eslint-disable-next-line eqeqeq
					if (obj.nm == 'H2TEXT') this.h2Color = this.rgbaobjtohex(obj.t.d.k[0].s.fc);
					// eslint-disable-next-line eqeqeq
					if (obj.nm == 'H3TEXT') this.h3Color = this.rgbaobjtohex(obj.t.d.k[0].s.fc);
					// eslint-disable-next-line eqeqeq
					if (obj.nm == 'H4TEXT') this.h4Color = this.rgbaobjtohex(obj.t.d.k[0].s.fc);
					// eslint-disable-next-line eqeqeq
					if (obj.nm == 'ELEMENT1') {
						$.each(obj.shapes[0].it, (j, objel1) => {
							// eslint-disable-next-line eqeqeq
							if (objel1.ty == 'fl') this.color1 = this.rgbaobjtohex(objel1.c.k);
						});
					}
					// eslint-disable-next-line eqeqeq
					if (obj.nm == 'ELEMENT2') {
						$.each(obj.shapes[0].it, (j, objel2) => {
							// eslint-disable-next-line eqeqeq
							if (objel2.ty == 'fl') this.color2 = this.rgbaobjtohex(objel2.c.k);
						});
					}
					// eslint-disable-next-line eqeqeq
					if (obj.nm == 'ELEMENT3') {
						$.each(obj.shapes[0].it, (j, objel3) => {
							// eslint-disable-next-line eqeqeq
							if (objel3.ty == 'fl') this.color3 = this.rgbaobjtohex(objel3.c.k);
						});
					}
					// eslint-disable-next-line eqeqeq
					if (obj.nm == 'ELEMENT4') {
						$.each(obj.shapes[0].it, (j, objel4) => {
							// eslint-disable-next-line eqeqeq
							if (objel4.ty == 'fl') this.color4 = this.rgbaobjtohex(objel4.c.k);
						});
					}
				}
			});
			if (!isSame) this.save(isSame);
		},
		initData() {
			this.isVisible = true;
			this.reset();
			if (this.data) {
				// this.isVisible = true;
				let content = duplicateVar(this.data.content);
				if (typeof content === 'string') {
					content = duplicateVar(JSON.parse(content));
				}
				this.layerIndex = this.data.layer_index;
				this.label = this.data.name;
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				}
				if (content) {
					if (content.template) {
						this.selectedTemplate = content.template;
						const isReset = !content.h1_color
										&& !content.h2_color
										&& !content.h3_color
										&& !content.h4_color
										&& !content.color_1
										&& !content.color_2
										&& !content.color_3
										&& !content.color_4;
						this.lottieDataChange(this.selectedTemplate, true, isReset);
						this.$emit('setTemplate', this.selectedTemplate);
					}
					this.h1 = content.h1;
					this.h2 = content.h2;
					this.h3 = content.h3;
					this.h4 = content.h4;
					this.duration = content.duration;
					this.mediaUrl = content.mediaUrl;
					this.mediaType = content.mediaType;
					this.mediaLabel = content.mediaLabel;
					this.font = content.font;
					this.fontSize = content.font_size;
					this.textDropShadow = content.textDropShadow;
					this.gradient = content.gradient;
					this.h1Color = content.h1_color;
					this.h2Color = content.h2_color;
					this.h3Color = content.h3_color;
					this.h4Color = content.h4_color;

					this.lottieSpeed = content.lottieSpeed;
					this.lottieScale = content.lottieScale;

					this.color1 = content.color_1;
					this.color2 = content.color_2;
					this.color3 = content.color_3;
					this.color4 = content.color_4;
					this.isRatio = content.isRatio;
					this.loop = content.loop || false;
					this.isParent = content.isParent || false;
					this.parentItem = this.filteredParent.find(item => item.id === content.parentItem) || '';
					if (content.width && content.width !== '') this.width = content.width;
					if (content.height && content.height !== '') this.height = content.height;
					if (content.position && content.position !== '') this.position = content.position;
					if (content.x && content.x !== '') this.x = content.x;
					if (content.y && content.y !== '') this.y = content.y;
					this.childOrder = this.delayList.find(item => item.id === content.childOrder);
				}
			}
		},
		uploadMedia(file) {
			const params = new FormData();
			params.append('file', file);
			if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
			const callback = (response) => {
				const mediaUrl = response.data;
				this.mediaUrl = mediaUrl;
				this.isUploadingMedia = false;
				this.mediaProgress = 0;
				this.addMedia();
				this.save();
				if (document.querySelector('#mediaInputLt')) document.querySelector('#mediaInputLt').value = '';
			};
			const errorCallback = (e) => {
				const messageFromCallback = getAxiosErrorMessage(e);
				const message = messageFromCallback && messageFromCallback !== '' ? messageFromCallback : 'Error when uploading file';
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Upload Media',
					text: message,
					duration: 999999999,
				});
				this.isUploadingMedia = false;
				this.mediaLabel = '';
				this.mediaFile = '';
				this.mediaUrl = '';
				this.mediaThumbnail = '';
			};
			const progressCallback = (progress) => {
				this.mediaProgress = progress;
			};
			fileApi.upload(params, callback, errorCallback, progressCallback);
		},
		// fetchMedia() {
		// 	this.isFetchingMedia = true;
		// 	const params = {
		// 		page: 1,
		// 		limit: 100,
		// 		order_by: this.orderBy,
		// 		sort_by: this.sortBy,
		// 		type: '',
		// 		category_id: 1,
		// 	};
		// 	if (this.activeRouteName === 'RundownEditor') {
		// 		params.rundown_id = this.rundown.id;
		// 	}
		// 	const callback = (response) => {
		// 		const medias = response.data;
		// 		this.mediaItems = medias;
		// 		this.isFetchingMedia = false;
		// 	};
		// 	const errorCallback = (e) => {
		// 		const message = getAxiosErrorMessage(e);
		// 		this.$notify({
		// 			group: 'app',
		// 			type: 'error',
		// 			title: 'Gallery Media',
		// 			text: message,
		// 		});
		// 		this.isFetchingMedia = false;
		// 	};
		// 	mediasApi.getList(params, callback, errorCallback);
		// },
		addMedia() {
			// this.isAdding = true;
			const params = {
				name: this.mediaLabel,
				path: this.mediaUrl,
				type: 'image',
				thumbnail: this.mediaThumbnail,
				rundown_id: this.rundown.id || null,
				category_id: 1,
				size: this.fileSize,
			};
			const callback = () => {
				// const item = response.data;
				// this.items.unshift(item);
				// this.isAdding = false;
			};
			const errorCallback = () => {
				// this.isAdding = false;
			};
			mediasApi.create(params, callback, errorCallback);
		},
		onMediaSelected(e) {
			this.initDataUser();
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // onegb
			}
			// upload
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
							if (this.rundownStorage && !this.isSuperAdmin) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									files = null;
									this.isCached = false;
									this.isCaching = false;
									if (document.querySelector('#mediaInputLt')) document.querySelector('#mediaInputLt').value = '';
									return;
								}
								// eslint-disable-next-line no-else-return
							}
							// if (!this.mediaItems.some(data => data.name === files[0].name) && !this.mediaItems.some(data => data.size === files[0].size)) {
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}
							this.isUploadingMedia = true;
							// Read image for preview
							const reader = new FileReader();
							reader.onload = (theFile) => {
								this.fileSize = file.size / oneMB;
								this.mediaFile = file;
								// Remove extension from filename to set label
								let filename = duplicateVar(file.name);
								filename = filename.split('.').slice(0, -1).join('.');
								this.mediaLabel = duplicateVar(filename);
								const fileType = 'image';
								this.mediaType = fileType;
								if (fileType === 'image') {
									const image = new Image();
									image.src = theFile.target.result;
									image.onload = () => {
										this.uploadMedia(file);
									};
								}
							};
							reader.readAsDataURL(file);
						// } else {
						// 	this.$notify({
						// 		group: 'app',
						// 		type: 'error',
						// 		text: 'File already exist, please upload another file',
						// 	});
						// 	files = null;
						// 	if (document.querySelector('#mediaInputLt')) document.querySelector('#mediaInputLt').value = '';
						// }
						} else {
							files = null;
							if (document.querySelector('#mediaInputLt')) document.querySelector('#mediaInputLt').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						if (document.querySelector('#mediaInputLt')) document.querySelector('#mediaInputLt').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				// const roles = this.user && this.user.roles ? this.user.roles : [];
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048; // onegb
				}
			}
		},
		reset() {
			this.selectedTemplate = null;
			this.h1 = '';
			this.h2 = '';
			this.h3 = '';
			this.h4 = '';

			this.h1Color = '#FF00FF';
			this.h2Color = '#FFFF00';
			this.h3Color = '#FFFFFF';
			this.h4Color = '#FF0000';
			this.color1 = '#2222FF';
			this.color2 = '#467FDD';
			this.color3 = '#FF000F';
			this.color4 = '#F000FF';
			this.textDropShadow = false;
			this.gradient = false;
			this.isH1Active = false;
			this.isH2Active = false;
			this.isH3Active = false;
			this.isH4Active = false;
			this.isH1ColorActive = false;
			this.isH2ColorActive = false;
			this.isH3ColorActive = false;
			this.isH4ColorActive = false;
			this.isElement1Active = false;
			this.isElement2Active = false;
			this.isElement3Active = false;
			this.isElement4Active = false;

			this.loop = false;
			this.duration = '00:00';
			this.font = '';
			this.fontSize = '';
			this.width = 1920;
			this.height = 1080;
			this.position = 'default';
			this.layerIndex = 0;
			this.x = 0;
			this.y = 0;
			this.lottieSpeed = '1';
			this.lottieScale = 'default';
			if (this.template) {
				this.selectedTemplate = this.template;
			}
		},
		updatePosition() {
			// this.x = 0;
			// if (this.position === 'custom') {
			this.y = (this.height - 1080) * -1; // (lottie.height - canvas.height ) *- 1;
			// }
		},
		onKeywordChange() {
			delay(() => {
				this.save();
			}, 1200);
		},

		save(isSame = true) {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
				if (!isSame) this.cacheDisplays();
				this.$emit('close');
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			if (this.data) {
				rundownItemsApi.update(this.data.id, this.params, callback, errorCallback);
			} else {
				rundownItemsApi.create(this.params, callback, errorCallback);
			}
		},
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		openTemplate() {
			this.$emit('browse');
		},
		hideAllPicker() {
			this.isshowColorPickerh2Color = false;
			this.isshowColorPickerh1Color = false;
			this.isshowColorPickerh3Color = false;
			this.isshowColorPickerh4Color = false;
			this.isshowColorPickerColor1 = false;
			this.isshowColorPickerColor2 = false;
			this.isshowColorPickerColor3 = false;
			this.isshowColorPickerColor4 = false;
		},
		// check duplicate layer_index
		checkDuplicateIndex() {
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.layerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = 'Other item also using this layer, only one item at a time will be displayed';
			return text1;
		},
		openGallery() {
			this.$emit('browseMedia');
		},
		async resetSizePosition() {
			let content = duplicateVar(this.data.content);
			if (typeof content === 'string') {
				content = duplicateVar(JSON.parse(content));
			}
			this.layerIndex = this.data.layer_index;
			this.label = this.data.name;
			if (content) {
				if (content.template) {
					const url = content.template && content.template.file_path ? content.template.file_path : null;
					// this.deactiveTemplateProperty();
					if (url) {
						const data = await (await fetch(url)).json();
						if (data.w && data.h) {
							this.width 	= data.w;
							this.height	= data.h;
						}
						this.x = 0;
						this.y = 0;
					}
				}
				this.save();
			}
		},
		rgbaobjtohex(obj) {
			const r = Math.round(obj[0] * 255);
			const g = Math.round(obj[1] * 255);
			const b = Math.round(obj[2] * 255);
			const a = (obj[3] !== undefined) ? Math.round(obj[3] * 255).toString(16) : '';
			// eslint-disable-next-line no-bitwise
			// eslint-disable-next-line no-bitwise
			return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}${a}`;
		},
		cacheDisplays() {
			const callback = () => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Media Saved',
					text: `Rebuilding cache for ${this.data.name}`,
				});
			};
			const callbackError = () => {
			};
			const params = {
				display_name: '',
			};
			rundownItemsApi.cacheDisplay(this.data.id, params, callback, callbackError);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientUser: 'clientUser',
			isClient: 'isClient',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
		}),
		filteredParent() {
			const filteredParent = this.items.filter(item => item.id !== this.data.id);
			return filteredParent;
		},
		rundownStorage() {
			return {
				total_max_file_size: this.rundown && this.rundown.total_max_file_size ? this.rundown.total_max_file_size : 0,
				total_remaining_size: this.rundown && this.rundown.total_remaining_size ? this.rundown.total_remaining_size : 0,
				total_used_file_size: this.rundown && this.rundown.total_used_file_size ? this.rundown.total_used_file_size : 0,
			};
		},
		isPlayingLive() {
			return this.data && !!this.data.is_play_live && this.data.is_play_live === 1;
		},
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		userSettings() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return settings;
		},
		params() {
			const label = this.label.trim();
			const parentItemId = this.parentItem && this.parentItem.id ? this.parentItem.id : null;
			const content = {
				template: this.selectedTemplate,

				h1: this.h1,
				h2: this.h2,
				h3: this.h3,
				h4: this.h4,

				textDropShadow: this.textDropShadow,
				gradient: this.gradient,
				isRatio: this.isRatio,

				label: this.label,
				mediaUrl: this.mediaUrl,
				mediaType: this.mediaType,
				mediaLabel: this.mediaLabel,
				duration: this.duration,
				font: this.font,
				font_size: this.fontSize,

				h1_color: this.h1Color,
				h2_color: this.h2Color,
				h3_color: this.h3Color,
				h4_color: this.h4Color,

				color_1: this.color1,
				color_2: this.color2,
				color_3: this.color3,
				color_4: this.color4,

				width: this.width,
				height: this.height,
				position: this.position,
				lottieSpeed: this.lottieSpeed,
				lottieScale: this.lottieScale,
				x: this.x,
				y: this.y,
				loop: this.loop,
				isDefault: false,
				isParent: this.isParent,
				parentItem: parentItemId,
				childOrder: this.childOrder && this.childOrder.id ? this.childOrder.id : 0,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: label,
				type: 'lower_third',
				content: contentString,
				layer_index: this.layerIndex,
				rundown_id: this.rundownId,
			};
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			return params;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.layerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
	},
	// mounted() {
	// },
	created() {
		if (this.clientUser) {
			this.localClientUser = this.clientUser;
		}
		this.isRequired = false;
		this.$nextTick(() => {
			this.initData();
		});
		this.isLoading = true;
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 300);
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	destroyed() {
		this.reset();
	},
	watch: {
		template() {
			if (this.template) {
				if (this.selectedTemplate !== this.template) {
					const isSame = this.selectedTemplate === this.template;
					this.selectedTemplate = this.template;
					// this.$nextTick(() => {
					this.$nextTick(() => {
						const lottieKey = `lottie_lt_${this.data.id}`;
						localforage.removeItem(lottieKey).then(() => {
							this.lottieDataChange(this.selectedTemplate, isSame, true, true);
						});
					});
				}
			}
		},
		media() {
			if (this.media) {
				this.mediaUrl = this.media.path;
				this.mediaLabel = this.media.name;
				this.mediaType = this.media.type;
				// Update Media
				if (this.mediaType === 'image') {
					const image = new Image();
					image.src = this.mediaUrl;
					image.onload = () => {
						const originalWidth = image.width;
						const originalHeight = image.height;
						this.mediaWidth = originalWidth;
						this.mediaHeight = originalHeight;
						this.save();
					};
				} else {
					this.videoUrl = this.media.path;
				}
			}
		},
		data() {
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = duplicateVar(JSON.parse(content));
				}
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				} else {
					this.isActiveEdit = false;
				}
				this.label = this.data.name;
				if (content && this.isActiveEdit) {
					this.layerIndex = this.data.layer_index;
					if (content.template) {
						if (this.selectedTemplate !== content.template) {
							this.selectedTemplate = content.template;
							const isSame = this.selectedTemplate === content.template;
							this.$nextTick(() => {
								this.lottieDataChange(this.selectedTemplate, isSame);
							});
							this.$emit('setTemplate', this.selectedTemplate);
						}
					}
					this.h1 = content.h1;
					this.h2 = content.h2;
					this.h3 = content.h3;
					this.h4 = content.h4;
					this.duration = content.duration;
					this.mediaUrl = content.mediaUrl;
					this.mediaType = content.mediaType;
					this.mediaLabel = content.mediaLabel;
					this.font = content.font;
					this.fontSize = content.font_size;
					this.textDropShadow = content.textDropShadow;
					this.gradient = content.gradient;
					this.h1Color = content.h1_color;
					this.h2Color = content.h2_color;
					this.h3Color = content.h3_color;
					this.h4Color = content.h4_color;

					this.color1 = content.color_1;
					this.color2 = content.color_2;
					this.color3 = content.color_3;
					this.color4 = content.color_4;
					this.isRatio = content.isRatio;
					this.loop = content.loop || false;
					this.isParent = content.isParent;
					this.parentItem = this.filteredItems.find(item => item.id === content.parentItem) || '';
					this.childOrder = this.delayList.find(item => item.id === content.childOrder);
				}
				if (content) {
					if (content.width && content.width !== '') this.width = content.width;
					if (content.height && content.height !== '') this.height = content.height;
					if (content.position && content.position !== '') this.position = content.position;
					if (content.x && content.x !== '') this.x = content.x;
					if (content.y && content.y !== '') this.y = content.y;
				}
			}
		},
	},
};
</script>
